// import Slick from 'vue-slick'
// export default defineNuxtPlugin((nuxtApp) => {
//     nuxtApp.vueApp.component('Slick', Slick)
//   })